<template>

  <body style="direction: rtl; text-align: right;">
    <Header />
    <!-- **************** MAIN CONTENT START **************** -->
    <main>
      <div v-if="loading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else>
        <div class="container">
          <div class="row g-4" style="">
            <!-- Sidenav START -->
            <div class="col-lg-3">
              <!-- Navbar START-->
              <nav class="navbar navbar-expand-lg mx-0">
                <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasSideNavbar">
                  <!-- Offcanvas header -->
                  <div class="offcanvas-header">
                    <button type="button" class="btn-close text-reset ms-auto" data-bs-dismiss="offcanvas"
                      aria-label="Close"></button>
                  </div>
                  <!-- Offcanvas body -->
                  <div class="offcanvas-body d-block px-2 px-lg-0">
                    <!-- Card START -->
                    <div class="card overflow-hidden shadow-lg">
                      <!-- Cover image -->
                      <div class="h-50px"
                        style="background: linear-gradient(90deg, #296080, #3c8dbc); background-size: cover;"></div>
                      <!-- Card body START -->
                      <div class="card-body pt-0">
                        <div class="text-center">
                          <!-- Avatar -->
                          <div class="avatar avatar-lg mt-n5 mb-3">
                            <a href="#!">
                              <img v-if="userData.users_image"
                                class="avatar-img rounded-circle shadow border border-white border-3"
                                :src="userData.users_image ? `https://zadcodeonline.com//ahmad/etqan/backEnd/upload/profile/${userData.users_image}` : 'assets/images/avatar/default-avatar.jpg'"
                                alt="صورة المستخدم" />
                              <img v-else class="avatar-img rounded-circle shadow border border-white border-3"
                                src="assets/person.png" alt="صورة افتراضية" />
                            </a>
                          </div>
                          <!-- Info -->
                          <h5 class="mb-1 text-primary">
                            <a href="#!">{{ userData.users_name || 'اسم غير متوفر' }}</a>
                          </h5>
                          <p class=" mb-0"><i class="bi bi-envelope-fill me-2"></i>{{ userData.users_email ||
                            'البريد غير متوفر' }}</p>
                          <p class=" mt-1"><i class="bi bi-telephone-fill me-2"></i>{{ userData.users_phone ||
                            'الهاتف غير متوفر' }}</p>
                          <!-- User Ratings -->
                          <div class="mt-3">
                            <template v-if="userData.points && userData.points > 0">
                              <span class="text-warning">
                                <!-- Render stars dynamically -->
                                <i v-for="n in Math.floor(userData.points)" :key="n" class="bi bi-star-fill"></i>
                                <i v-if="userData.points % 1 !== 0" class="bi bi-star-half"></i>
                                <i v-for="n in 5 - Math.ceil(userData.points)" :key="`empty-${n}`"
                                  class="bi bi-star"></i>
                              </span>
                              <p class="small  mt-1">التقييم: {{ userData.points.toFixed(1) || '0.0' }} / 5
                              </p>
                            </template>
                            <template v-else>
                              <p class=" mt-1"></p>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="card-footer text-center py-2">
                        <router-link to="/profile" style="background-color: #296080; color:#fff" class="btn  btn-sm">
                          <i class="bi bi-person-fill me-1"></i> الملف الشخصي
                        </router-link>
                      </div>
                    </div>

                    <p class="small text-center mt-1">©2025 <a class="text-body" target="_blank" href="#"> </a></p>
                  </div>
                </div>
              </nav>
            </div>

            <div class="col-md-8 col-lg-6 vstack gap-3">
              <!-- Carousel with Shadow -->
              <div id="carouselExample" class="carousel slide shadow-lg" data-bs-ride="carousel"
                style="border-radius: 15px;">
                <div class="carousel-inner">
                  <!-- العناصر المتغيرة بناءً على البيانات -->
                  <div v-for="(ad, index) in ads" :key="ad.ads_id" :class="['carousel-item', { active: index === 0 }]">
                    <a :href="ad.ads_url" target="_blank">
                      <img :src="`https://zadcodeonline.com//ahmad/etqan/backEnd/upload/ads/${ad.ads_image}`"
                        class="d-block w-100" :alt="ad.ads_name" style="border-radius: 15px;" />
                    </a>
                  </div>
                </div>
                <!-- أزرار التنقل -->
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample"
                  data-bs-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">السابق</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExample"
                  data-bs-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="visually-hidden">التالي</span>
                </button>
              </div>

              <div class="card card-body" style="border-radius: 25px; padding: 0;">
                <div class="d-flex align-items-center" style="direction: rtl; text-align: right;">
                  <!-- Avatar -->
                  <div class="avatar avatar-xs me-3">
                    <img v-if="userData.users_image" class="avatar-img rounded-circle"
                      :src="userData.users_image ? `https://zadcodeonline.com//ahmad/etqan/backEnd/upload/profile/${userData.users_image}` : 'assets/images/avatar/default-avatar.jpg'"
                      alt="صورة المستخدم" />
                    <img v-else class="avatar-img rounded-circle" src="assets/person.png" alt="صورة افتراضية" />
                  </div>
                  <!-- Post input -->
                  <router-link to="/share-post" class="w-100">
                    <form class="w-100">
                      <input type="text" style="border-radius: 20px; padding: 1.5rem 1rem;"
                        class="form-control border-0 w-100" :placeholder="` شارك أعمالك أو قم بطلب خدمة!`">
                    </form>
                  </router-link>
                </div>
              </div>

              <!-- Posts Cards -->
              <div v-for="post in posts" :key="post.posts_id">
                <PostCard :post="post" />
              </div>

              <div v-if="isLoadingMore" class="text-center mt-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>

            <div class="col-lg-3 catigoryCard">
              <div class="row g-4">
                <div class="col-sm-6 col-lg-12">
                  <div class="card" style="direction: rtl; text-align: right;">
                    <div class="card-header pb-0 border-0">
                      <p style="font-weight: bold;" class="card-title mb-0">المهن المتوفرة</p>
                    </div>
                    <!-- <div class="card-body" id="categories-container">
                    </div> -->
                    <div id="categories-container">
                      <div class="mb-3 me-2" v-for="category in categories" :key="category.categories_id">
                        <p class="mb-0">
                          <a href="#" :style="{ color: category.categories_color }">
                            {{ category.categories_name }}
                          </a>
                        </p>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </main>
  </body>
</template>


<script>
import Header from '../components/header.vue';
import Footer from '../components/footer.vue';
import PostCard from "../components/PostCard.vue";
import axios from 'axios';

export default {
  name: "HelloWorld",
  components: {
    Header,
    Footer,
    PostCard,
  },
  data() {
    return {
      userData: {},
      userId: localStorage.getItem("userId"),
      loading: true,
      categories: [],
      ads: [],
      posts: [],
      limit: 3,
      offset: 0,
      isLoadingMore: false,
      noMorePosts: false,
    };
  },
  mounted() {
    this.loadInitialData();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async loadInitialData() {
      // تحقق مما إذا كانت البيانات موجودة في localStorage
      const cachedData = localStorage.getItem('cachedPageData');
      if (cachedData) {
        const parsedData = JSON.parse(cachedData);
        this.userData = parsedData.userData;
        this.categories = parsedData.categories;
        this.ads = parsedData.ads;
        this.posts = parsedData.posts;
        this.offset = parsedData.offset;
        this.noMorePosts = parsedData.noMorePosts;
        this.loading = false;
      } else {
        // إذا لم تكن البيانات موجودة، قم بجلبها من الخادم
        await this.fetchUserData(this.userId);
        await this.fetchCategories();
        await this.fetchAds();
        await this.fetchPosts();
        this.loading = false;
      }
    },
    async fetchUserData(userId) {
      try {
        const response = await axios.post(
          'https://zadcodeonline.com/ahmad/etqan/backEnd/profiles/view.php',
          { usersid: userId },
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        if (response.data.status === "success") {
          this.userData = response.data.data;
          this.saveDataToLocalStorage(); // حفظ البيانات في localStorage
        }
      } catch (error) {
        console.error("خطأ أثناء جلب بيانات المستخدم:", error);
      }
    },
    async fetchCategories() {
      try {
        const response = await axios.post(
          'https://zadcodeonline.com/ahmad/etqan/backEnd/categories/view.php',
          {},
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        if (response.data.status === 'success') {
          this.categories = response.data.data;
          this.saveDataToLocalStorage(); // حفظ البيانات في localStorage
        }
      } catch (error) {
        console.error('حدث خطأ أثناء جلب البيانات:', error);
      }
    },
    async fetchAds() {
      try {
        const response = await axios.get('https://zadcodeonline.com/ahmad/etqan/backEnd/ads/view.php');
        if (response.data.status === 'success') {
          this.ads = response.data.data;
          this.saveDataToLocalStorage(); // حفظ البيانات في localStorage
        }
      } catch (error) {
        console.error('خطأ في جلب البيانات:', error);
      }
    },
    async fetchPosts() {
      if (this.isLoadingMore || this.noMorePosts) return;
      this.isLoadingMore = true;
      try {
        const response = await axios.post(
          'https://zadcodeonline.com/ahmad/etqan/backEnd/posts/view.php',
          {
            limit: this.limit,
            offset: this.offset,
            userId: this.userId,
          },
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        if (response.data.status === 'success') {
          const newPosts = response.data.data;
          if (newPosts.length === 0) {
            this.noMorePosts = true;
          } else {
            this.posts = [...this.posts, ...newPosts];
            this.offset += this.limit;
            this.saveDataToLocalStorage(); // حفظ البيانات في localStorage
          }
        }
      } catch (error) {
        console.error('خطأ أثناء جلب المنشورات:', error);
      } finally {
        this.isLoadingMore = false;
      }
    },
    saveDataToLocalStorage() {
      const dataToCache = {
        userData: this.userData,
        categories: this.categories,
        ads: this.ads,
        posts: this.posts,
        offset: this.offset,
        noMorePosts: this.noMorePosts,
      };
      localStorage.setItem('cachedPageData', JSON.stringify(dataToCache));
    },
    handleScroll() {
      const scrollPosition = window.scrollY + window.innerHeight;
      const bottomPosition = document.documentElement.offsetHeight;

      if (scrollPosition >= bottomPosition - 200 && !this.isLoadingMore && !this.noMorePosts) {
        this.fetchPosts();
      }
    },
  },
};
</script>


<style scoped>
#carouselExample {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.7);
  /* ظل خفيف */
  border-radius: 15px;
  /* زوايا مستديرة */
  overflow: hidden;
  /* لمنع الظل من الظهور خارج الحدود */
}

.carousel-item img {
  border-radius: 15px;
  height: 200px;
  object-fit: cover;
}

.carousel-inner {
  border-radius: 15px;
  overflow: hidden;
}



.carousel-item img:hover {
  transform: scale(1.03);
  /* تأثير تكبير خفيف عند التمرير */
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4);
  /* زيادة تأثير الظل */
}


.card-header {
  color: #296080;
  padding: 1rem 1rem;
  border-radius: 30px;
}

.card-body {
  padding: 1.25rem 1.25rem 0 1.25rem;
}

li {
  display: inline-block;
  margin: 0 0 !important;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  color: #333;
  transition: color 0.3s ease;
}

.nav-link:hover {
  color: #296080;
}

.loading-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 9999;
}

.spinner-border {
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.fade-in {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeIn 0.8s ease-out forwards;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}


.post-images-container {
  margin-top: 15px;
}

.single-image img {
  width: 100%;
  height: auto;
}

.two-images img {
  width: 49%;
  /* تقسيم العرض بالتساوي */
  height: auto;
}

.three-or-more-images {
  display: flex;
  flex-wrap: wrap;
}

.three-or-more-images .main-image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.three-or-more-images .other-images img {
  width: 49%;
  /* نصف العرض */
  height: 100px;
  object-fit: cover;
  position: relative;
}

.three-or-more-images .overlay {
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  width: 49%;
  z-index: 1;
}

.carousel-caption h5 {
  font-size: 1.5rem;
  color: #fff;
}

.carousel-caption p {
  font-size: 1rem;
  color: #fff;
}

a {
  color: #296080;
}



h3 {
  /* margin: 40px 0 0; */
  margin: 40px 0 10px;
  font-size: 1.8rem;
  color: #333;
  font-weight: 600;
  text-align: center;
}

/* تحسين القوائم */
ul {
  list-style-type: none;
  padding: 0;
  text-align: center;
}

li {
  display: inline-block;
  margin: 0 15px;
}

a {
  color: #296080;
  font-size: 1.1rem;
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: #004d73;
  /* font-weight: bold; */
}

.text-itkan {
  font-size: 25px;
  color: #ffffff;
}

.text-person {
  font-weight: bold;
  color: #296080;
  font-size: 1.2rem;
}

.text-date {
  font-size: 0.7rem;
  color: #6c757d;
}

.rounded-card {
  border-radius: 25px;
  overflow: hidden;
}



@media (max-width: 992px) {
  .carousel-item img {
    border-radius: 30px;
    height: 200px;
    object-fit: cover;
  }

  .row>* {
    margin-top: 10px;
  }
}

@media (max-width: 992px) {
  .catigoryCard {
    display: none;
  }

  .navbar-light .navbar-nav .nav-link[data-v-5e4cad4c] {
    color: #296080;
  }

  .navbar>.container,
  .navbar>.container-fluid,
  .navbar>.container-sm,
  .navbar>.container-md,
  .navbar>.container-lg,
  .navbar>.container-xl,
  .navbar>.container-xxl {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: inherit;
    flex-wrap: inherit;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    flex-direction: row-reverse;
  }
}

body {
  background: linear-gradient(to bottom, #f5f7fa, #e3f2fd);
  font-family: "Tajawal", sans-serif;
}

.card {
  border-radius: 30px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, box-shadow 0.3s;
  background: linear-gradient(to top, #ffffff, #f8f9fa);
}

.card:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.carousel-inner img {
  border-radius: 15px;
}

.carousel-caption h5 {
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
}

.navbar {
  border-radius: 10px;
}

.nav-link {
  color: #296080 !important;
  transition: color 0.3s;
}

.nav-link:hover {
  color: #614900 !important;
}

.btn {
  border-radius: 15px;
  padding: 10px 20px;
  font-size: 1.1rem;
  transition: all 0.3s;
}

.btn-primary-soft {
  color: #296080;
  border: 1px solid #bbdefb;
}

.btn-primary-soft:hover {
  background-color: #296080;
  color: #fff;
  border: 1px solid #296080;
}

.loading-overlay {
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050;
}

.spinner-border {
  width: 3.5rem;
  height: 3.5rem;
  border-width: 0.3rem;
}


.avatar:hover {
  border-color: #ffc107;
}


.text-date {
  font-size: 0.85rem;
  color: #6c757d;
}

.carousel-item {
  transition: transform 0.8s ease, opacity 0.8s ease;
}

.carousel-inner .active {
  animation: slideIn 0.8s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}


.post-images-container img {
  border-radius: 15px;
  transition: transform 0.3s, box-shadow 0.3s;
}

.post-images-container img:hover {
  transform: scale(1.01);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.overlay {
  position: relative;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 10px;
  text-align: center;
  line-height: 100px;
}

.scroll-reveal {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-in-out;
}

.scroll-reveal.visible {
  opacity: 1;
  transform: translateY(0);
}
</style>